<script setup lang="ts">
import type { Swiper, SwiperEvents } from 'swiper/types';

const { swiper } = defineProps<{ swiper: Swiper }>();

const controlsDisabled = reactive({
  prev: true,
  next: false,
});

onMounted(() => {
  swiper.onAny(updateDisabledState);
});
onBeforeUnmount(() => {
  swiper.offAny(updateDisabledState);
});

function updateDisabledState(event: string) {
  const events: (keyof SwiperEvents)[] = ['slidesUpdated', 'slideChange'];
  if (events.includes(event as keyof SwiperEvents)) {
    controlsDisabled.prev = swiper.isBeginning;
    controlsDisabled.next = swiper.isEnd;
  }
}
</script>

<template>
  <div class="gap-r2 sm:gap-r4 flex">
    <AppSwiperControlsButton
      :disabled="controlsDisabled.prev"
      @click="swiper.slidePrev()"
    >
      <SVGArrowRounded class="w-3 sm:w-4.5" />
    </AppSwiperControlsButton>
    <AppSwiperControlsButton
      :disabled="controlsDisabled.next"
      @click="swiper.slideNext()"
    >
      <SVGArrowRounded class="w-3 rotate-180 sm:w-4.5" />
    </AppSwiperControlsButton>
  </div>
</template>
